// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "c836877b7be8aecc8e958d57815152c22668fe00/scripts/" + chunkId + ".js";
};